import { Injectable } from '@angular/core';
import { NanorepInterface, SmartAdvisorWidget } from 'shared/components/nanorep-panel/nanorep-sdk';
import { NanorepAccountInfoModel } from 'common/api/models/nanorep-account-info.model';

@Injectable()
export class SmartAdvisorLoaderService {
  private _loadPromise: Promise<void>;
  public loadScript(accountInfo: NanorepAccountInfoModel): Promise<void> {
    if (!accountInfo) {
      return Promise.resolve();
    }

    if (!this._loadPromise) {
      this._loadPromise = new Promise<void>((resolve, reject) => {
        const account = accountInfo.nanorepAccountName;
        const host = accountInfo.nanorepHost;

        // create product and widget namespace
        let nanorepNS: NanorepInterface = window.nanorep = window.nanorep || {};
        let smartAdvisorNS: SmartAdvisorWidget = nanorepNS.smartAdvisorWidget = nanorepNS.smartAdvisorWidget || {};

        // save customer's host to avoid searching and parsing
        smartAdvisorNS.apiHost = host;
        smartAdvisorNS.host = host;
        smartAdvisorNS.path = '/web/';
        smartAdvisorNS.account = account;
        smartAdvisorNS.protocol = 'https:';

        // build script url
        const url = `//${host}/web/smart-advisor-widget.js?account=${account}`;
        const script = document.createElement('script');

        // load script immediately after this embed code is executed
        script.async = script.defer = true;
        script.onload = () => resolve();
        script.onerror = () => reject();
        script.setAttribute('src', url);
        document.getElementsByTagName('head')[0].appendChild(script);
      });
    }
    return this._loadPromise;
  }
}
